import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScopeLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2341_110902)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M3.86127 66.4627C4.15039 68.2242 4.68634 68.5592 6.54254 67.5582M10.5789 66.0591L11.3285 65.4248",
				stroke: "black",
				strokeWidth: .5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M80.1181 21.8859L80.856 22.8046M81.5938 23.7234L80.856 22.8046M80.856 22.8046L81.7027 22.1246M80.856 22.8046L79.9613 23.5232",
				stroke: "black",
				strokeWidth: .5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.0067 18.8115C71.1342 20.788 72.4191 20.8606 74.956 18.3778M74.956 18.3778L73.6118 18.6859M74.956 18.3778L74.8119 19.5658",
				stroke: "#4F49BA",
				strokeWidth: .5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.7332 89.6124L21.1369 91.4991C21.1418 91.5222 21.1622 91.5386 21.1858 91.5386H21.7867C21.6832 91.796 21.4313 91.9778 21.1369 91.9778H4.67618C4.28958 91.9778 3.97618 91.6644 3.97618 91.2778V90.6124H2.59825C2.21166 90.6124 1.89825 90.299 1.89825 89.9124V88.947C1.89825 88.5604 2.21165 88.247 2.59825 88.247H4.27955V87.8815H4.02772C3.64112 87.8815 3.32772 87.5681 3.32772 87.1815V85.6218C3.32772 85.2352 3.64112 84.9218 4.02772 84.9218H5.67946V84.1326C5.67946 83.746 5.99286 83.4326 6.37946 83.4326H19.4113L19.6252 84.4326H6.67946V84.9218H19.7298L19.9438 85.9218H4.32772V86.8815H20.1491L20.363 87.8815H5.27955V88.247L20.4412 88.247L20.6551 89.247L2.89825 89.247V89.6124H20.7332ZM4.97618 90.9778V90.6124H20.8369V90.9778H4.97618Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63.4828 22.4638L20.3038 21.8245C19.1027 21.8067 18.157 22.8442 18.2857 24.0384L25.0095 86.4626C25.1199 87.4872 25.9907 88.2602 27.0211 88.2483L80.783 87.6272C80.8926 87.6259 80.9807 87.5368 80.9807 87.4272L80.9807 83.3484L32.2798 82.2876C31.8271 82.2876 31.4399 81.7995 31.3651 81.1432C27.5195 59.1559 21.7688 49.0849 20.8671 25.2462C20.787 24.4154 21.2314 23.6702 21.8021 23.6867L66.5625 24.977L66.1052 24.0895C65.5981 23.1052 64.59 22.4802 63.4828 22.4638Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M65.5067 23.051L64.8743 21.8708C64.3595 20.9103 63.3643 20.3045 62.2747 20.2883L14.1973 19.5734C13.597 19.5645 13.1241 20.083 13.1882 20.68L20.6974 90.6843C20.7524 91.1968 21.1879 91.5835 21.7033 91.5775L79.9923 90.9014C80.5401 90.895 80.9807 90.4492 80.9807 89.9014L80.9807 83.5354",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.3501 83.4729H83.9712C84.7997 83.4729 85.2754 82.5191 84.7978 81.842C80.0359 75.0906 76.2118 66.3689 73.2776 55.9437L70.5831 44.6884C69.2967 38.3146 68.276 31.4503 67.5131 24.1404C67.461 23.6411 67.0482 23.2562 66.5464 23.2413L18.7624 21.8232C18.1782 21.8059 17.7036 22.2917 17.7368 22.8753C19.2027 48.6324 25.0325 73.3536 32.5825 83.1055C32.7671 83.3439 33.0486 83.4729 33.3501 83.4729Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M73.2776 55.9437C76.2118 66.3689 80.0359 75.0906 84.7978 81.842C85.2754 82.5191 84.7997 83.4729 83.9712 83.4729H33.3501C33.0486 83.4729 32.7671 83.3439 32.5825 83.1055C25.0325 73.3536 19.2027 48.6324 17.7368 22.8753C17.7036 22.2917 18.1782 21.8059 18.7624 21.8232L66.5464 23.2413C67.0482 23.2562 67.461 23.6411 67.5131 24.1404C68.276 31.4503 69.2967 38.3146 70.5831 44.6884",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 22.7116,
				height: 1.03785,
				rx: .518926,
				transform: "matrix(0.999848 0.0174524 0.175211 0.89132 37.2299 33.4834)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 11.3558,
				height: 1.03785,
				rx: .518926,
				transform: "matrix(0.999848 0.0174524 0.175211 0.89132 37.7858 36.2656)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 7.3516,
				height: 7.06693,
				rx: 1,
				transform: "matrix(0.999848 0.0174524 0.251345 0.898717 24.7587 31.9375)",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.746 36.4198C28.1916 35.7682 27.5873 35.047 27.5754 34.9854C27.5628 34.92 28.1518 35.2354 28.6571 35.5168C29.0791 35.7517 29.561 35.762 29.8496 35.5345L34.1517 32.1424C34.1817 32.1187 34.2069 32.1274 34.1898 32.1604C33.9647 32.5958 31.597 35.2941 30.3762 36.673C30.016 37.0799 29.2006 36.9541 28.746 36.4198Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 22.7116,
				height: 1.03785,
				rx: .518926,
				transform: "matrix(0.999848 0.0174524 0.175211 0.89132 40.0169 46.0693)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 11.3558,
				height: 1.03785,
				rx: .518926,
				transform: "matrix(0.999848 0.0174524 0.175211 0.89132 40.5728 48.8516)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 7.3516,
				height: 7.06693,
				rx: 1,
				transform: "matrix(0.999848 0.0174524 0.251346 0.898717 27.5457 44.5234)",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 22.7116,
				height: 1.03785,
				rx: .518926,
				transform: "matrix(0.999848 0.0174524 0.175211 0.89132 44.5801 58.6562)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 11.3558,
				height: 1.03785,
				rx: .518926,
				transform: "matrix(0.999848 0.0174524 0.175211 0.89132 45.136 61.4385)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 7.3516,
				height: 7.06693,
				rx: 1,
				transform: "matrix(0.999848 0.0174524 0.251346 0.898717 32.1089 57.1104)",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "path-19-inside-1_2341_110902",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M34.6484 17.613H31.2918C30.1873 17.613 29.5116 18.481 29.7828 19.5518L30.5302 22.5034C30.8014 23.5742 31.9166 24.4422 33.0212 24.4422H50.1555C51.2601 24.4422 51.9357 23.5742 51.6645 22.5034L50.9171 19.5518C50.646 18.481 49.5307 17.613 48.4262 17.613H45.0695C44.0368 15.1906 41.3961 13.3447 38.7781 13.3447C36.1601 13.3447 34.4543 15.1906 34.6484 17.613Z"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M34.6484 17.613H31.2918C30.1873 17.613 29.5116 18.481 29.7828 19.5518L30.5302 22.5034C30.8014 23.5742 31.9166 24.4422 33.0212 24.4422H50.1555C51.2601 24.4422 51.9357 23.5742 51.6645 22.5034L50.9171 19.5518C50.646 18.481 49.5307 17.613 48.4262 17.613H45.0695C44.0368 15.1906 41.3961 13.3447 38.7781 13.3447C36.1601 13.3447 34.4543 15.1906 34.6484 17.613Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.6484 17.613L35.6753 17.7734L35.7401 18.5824H34.8939L34.6484 17.613ZM51.6645 22.5034H50.6645H51.6645ZM50.9171 19.5518H51.9171H50.9171ZM45.0695 17.613L45.315 18.5824H44.4688L44.1239 17.7734L45.0695 17.613ZM34.8939 18.5824H31.5373L31.0464 16.6436H34.403L34.8939 18.5824ZM31.5373 18.5824C30.985 18.5824 30.6472 19.0164 30.7828 19.5518H28.7828C28.3761 17.9456 29.3895 16.6436 31.0464 16.6436L31.5373 18.5824ZM30.7828 19.5518L31.5302 22.5034H29.5302L28.7828 19.5518H30.7828ZM31.5302 22.5034C31.6658 23.0388 32.2234 23.4728 32.7757 23.4728L33.2666 25.4116C31.6098 25.4116 29.9369 24.1095 29.5302 22.5034H31.5302ZM32.7757 23.4728H49.91L50.401 25.4116H33.2666L32.7757 23.4728ZM49.91 23.4728C50.4623 23.4728 50.8001 23.0388 50.6645 22.5034H52.6645C53.0713 24.1095 52.0578 25.4116 50.401 25.4116L49.91 23.4728ZM50.6645 22.5034L49.9171 19.5518H51.9171L52.6645 22.5034H50.6645ZM49.9171 19.5518C49.7815 19.0164 49.2239 18.5824 48.6716 18.5824L48.1807 16.6436C49.8375 16.6436 51.5104 17.9456 51.9171 19.5518H49.9171ZM48.6716 18.5824H45.315L44.824 16.6436H48.1807L48.6716 18.5824ZM44.1239 17.7734C43.287 15.8102 41.1451 14.3141 39.0236 14.3141L38.5327 12.3753C41.6472 12.3753 44.7867 14.5709 46.0151 17.4526L44.1239 17.7734ZM39.0236 14.3141C36.9021 14.3141 35.5179 15.8102 35.6753 17.7734L33.6216 17.4526C33.3906 14.5709 35.4182 12.3753 38.5327 12.3753L39.0236 14.3141Z",
				fill: "black",
				mask: "url(#path-19-inside-1_2341_110902)"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: .880597,
				cy: .880597,
				r: .880597,
				transform: "matrix(-1 0 0.245477 0.969403 40.1832 15.3262)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.7033 91.9824C10.7033 91.5477 11.0557 91.1953 11.4904 91.1953H95.2129C95.6476 91.1953 96 91.5477 96 91.9824H10.7033Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M64.1994 10.006C62.8429 10.1374 62.0888 9.9304 61.0207 9.2809C60.9417 9.23285 60.8429 9.30802 60.8675 9.39719C61.283 10.9038 61.2169 11.7348 60.656 12.8732C60.6159 12.9547 60.6957 13.0468 60.7824 13.0193C62.2585 12.5506 63.0162 12.7787 64.0898 13.4143C64.1736 13.4639 64.2749 13.3772 64.2393 13.2866C63.6687 11.8375 63.7023 11.0909 64.2971 10.1676C64.3439 10.095 64.2854 9.99767 64.1994 10.006Z",
				stroke: "black",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0861 34.8528C8.62174 34.3295 8.17974 33.7589 8.06649 32.6421C8.06061 32.5841 7.96582 32.5761 7.95045 32.6323C7.58301 33.9767 7.0363 34.52 5.84765 34.8318C5.78934 34.847 5.79947 34.9577 5.85955 34.9628C7.38545 35.0927 7.75273 35.7823 7.98546 37.1152C7.99539 37.1721 8.08345 37.172 8.0931 37.1151C8.34946 35.6027 8.82497 35.079 10.0729 34.9596C10.1281 34.9543 10.1383 34.8714 10.0861 34.8528Z",
				stroke: "#4F49BA",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 7.85657,
				cy: 12.4027,
				r: 1.17029,
				stroke: "black",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.02686 54.8499C10.6964 53.6549 11.6286 52.9493 13.2518 51.3262",
				stroke: "black",
				strokeWidth: .5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 11.4171,
				cy: 55.4186,
				r: .469421,
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 13.3782,
				cy: 52.872,
				r: .251901,
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M67.3767 48.0394C66.5474 48.1215 65.9464 48.3278 65.1918 48.8391C64.8979 49.0383 64.7536 49.3932 64.8049 49.7446C65.1555 52.146 65.703 53.628 66.8777 55.7945C67.0709 56.1508 67.4653 56.3541 67.8658 56.291C68.8212 56.1404 69.4753 55.926 70.1853 55.4258C70.4909 55.2104 70.6138 54.823 70.5271 54.4593C70.4762 54.2459 70.4257 54.0397 70.375 53.8395L73.1372 52.7334C73.4348 52.6142 73.7766 52.6387 74.0289 52.8364C74.4606 53.1743 74.7491 53.5311 75.0723 53.9942C75.315 54.342 75.7458 54.509 76.1554 54.3988C76.3718 54.3406 76.5815 54.2831 76.7855 54.2259L81.2132 67.5261L81.9565 69.8686L88.3236 89.9338C88.5835 90.7528 89.3131 91.3521 90.1723 91.3532C92.06 91.3555 93.2257 90.9302 94.4087 89.7779C94.9461 89.2545 95.0631 88.4492 94.8043 87.7451L87.3707 67.5261L86.4382 64.9897L81.707 52.4209C81.9931 52.2858 82.2872 52.1422 82.5933 51.9884C82.9939 51.7871 83.2055 51.3392 83.1135 50.9003L82.8448 49.6184C82.7279 49.0606 83.1003 48.5141 83.667 48.4541C86.512 48.153 88.6563 48.676 92.1661 49.9579C92.3322 50.0185 92.4854 49.855 92.3981 49.7013C90.8064 46.8995 85.5256 43.5814 80.7047 43.7535C77.5688 44.1877 75.743 44.6707 72.8224 46.1052C72.4843 46.2713 72.2726 46.6172 72.2726 46.9939L72.2726 47.5627C72.2726 47.9204 72.0835 48.255 71.7652 48.4183C70.946 48.8384 70.1805 49.0789 68.7245 49.3599C68.5853 49.0897 68.4354 48.8114 68.2727 48.5211C68.0922 48.1992 67.744 48.003 67.3767 48.0394Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.375 53.8395C70.4257 54.0397 70.4762 54.2459 70.5271 54.4593C70.6138 54.823 70.4909 55.2104 70.1853 55.4258C69.4753 55.926 68.8212 56.1404 67.8658 56.291C67.4653 56.3541 67.0709 56.1508 66.8777 55.7945C65.703 53.628 65.1555 52.146 64.8049 49.7446C64.7536 49.3932 64.8979 49.0383 65.1918 48.8391C65.9464 48.3278 66.5474 48.1215 67.3767 48.0394C67.744 48.003 68.0922 48.1992 68.2727 48.5211C68.4354 48.8114 68.5853 49.0897 68.7245 49.3599M70.375 53.8395L73.1372 52.7334C73.4348 52.6142 73.7766 52.6387 74.0289 52.8363C74.4606 53.1743 74.7491 53.5311 75.0722 53.9942C75.315 54.342 75.7458 54.509 76.1554 54.3988C78.7018 53.7138 80.3188 53.1312 82.5933 51.9884C82.994 51.7871 83.2055 51.3392 83.1135 50.9003L82.8448 49.6184C82.7279 49.0606 83.1003 48.5141 83.667 48.4541C86.512 48.153 88.6563 48.676 92.1661 49.9579C92.3322 50.0185 92.4854 49.855 92.3981 49.7013C90.8064 46.8995 85.5256 43.5814 80.7047 43.7535C77.5688 44.1877 75.743 44.6707 72.8224 46.1052C72.4843 46.2713 72.2726 46.6172 72.2726 46.9939L72.2726 47.5627C72.2726 47.9204 72.0835 48.255 71.7652 48.4183C70.946 48.8384 70.1805 49.0789 68.7245 49.3599M70.375 53.8395C69.9464 52.1447 69.5072 50.8804 68.7245 49.3599M76.7855 54.2259L81.2132 67.5261M81.707 52.4209L86.4382 64.9897M81.9565 69.8686L88.3236 89.9338C88.5835 90.7528 89.3131 91.3521 90.1723 91.3532C92.06 91.3555 93.2257 90.9302 94.4087 89.7779C94.9461 89.2545 95.0631 88.4492 94.8043 87.7451L87.3707 67.5261M81.9565 69.8686C84.5048 69.7401 85.6898 69.2507 87.3707 67.5261M81.9565 69.8686L81.2132 67.5261M87.3707 67.5261L86.4382 64.9897M81.2132 67.5261C83.6864 67.0307 84.8389 66.4943 86.4382 64.9897",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M67.3768 48.0394C66.5474 48.1215 65.9464 48.3278 65.1919 48.8391C64.8979 49.0383 64.7536 49.3932 64.8049 49.7446C65.1555 52.146 65.7031 53.628 66.8777 55.7945C67.0709 56.1508 67.4654 56.3541 67.8658 56.291C68.8212 56.1404 69.4753 55.926 70.1853 55.4258C70.4909 55.2104 70.6138 54.823 70.5271 54.4593C70.4762 54.2459 70.4257 54.0397 70.3751 53.8395L73.1373 52.7334C73.4348 52.6142 73.7766 52.6387 74.029 52.8364C74.4606 53.1743 74.7491 53.5311 75.0723 53.9942C75.315 54.342 75.7458 54.509 76.1554 54.3988C76.3719 54.3406 76.5816 54.2831 76.7856 54.2259C78.6586 53.7012 80.0476 53.2045 81.707 52.4209C81.9931 52.2858 82.2873 52.1422 82.5933 51.9884C82.994 51.7871 83.2056 51.3392 83.1136 50.9003L82.8449 49.6184C82.7279 49.0606 83.1004 48.5141 83.6671 48.4541C86.512 48.153 88.6563 48.676 92.1662 49.9579C92.3322 50.0185 92.4854 49.855 92.3981 49.7013C90.8064 46.8995 85.5256 43.5814 80.7047 43.7535C77.5688 44.1877 75.7431 44.6707 72.8224 46.1052C72.4843 46.2713 72.2726 46.6172 72.2726 46.9939L72.2726 47.5627C72.2726 47.9204 72.0835 48.255 71.7652 48.4183C70.946 48.8384 70.1806 49.0789 68.7245 49.3599C68.5854 49.0897 68.4354 48.8114 68.2727 48.5211C68.0923 48.1992 67.744 48.003 67.3768 48.0394Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.3751 53.8395C70.4257 54.0397 70.4762 54.2459 70.5271 54.4593C70.6138 54.823 70.4909 55.2104 70.1853 55.4258C69.4753 55.926 68.8212 56.1404 67.8658 56.291C67.4654 56.3541 67.0709 56.1508 66.8777 55.7945C65.7031 53.628 65.1555 52.146 64.8049 49.7446C64.7536 49.3932 64.8979 49.0383 65.1919 48.8391C65.9464 48.3278 66.5474 48.1215 67.3768 48.0394C67.744 48.003 68.0923 48.1992 68.2727 48.5211C68.4354 48.8114 68.5854 49.0897 68.7245 49.3599M70.3751 53.8395L73.1373 52.7334C73.4348 52.6142 73.7766 52.6387 74.029 52.8363C74.4606 53.1743 74.7491 53.5311 75.0723 53.9942C75.315 54.342 75.7458 54.509 76.1554 54.3988C78.7018 53.7138 80.3189 53.1312 82.5933 51.9884C82.994 51.7871 83.2056 51.3392 83.1136 50.9003L82.8449 49.6184C82.7279 49.0606 83.1004 48.5141 83.6671 48.4541C86.512 48.153 88.6563 48.676 92.1662 49.9579C92.3322 50.0185 92.4854 49.855 92.3981 49.7013C90.8064 46.8995 85.5256 43.5814 80.7047 43.7535C77.5688 44.1877 75.7431 44.6707 72.8224 46.1052C72.4843 46.2713 72.2726 46.6172 72.2726 46.9939L72.2726 47.5627C72.2726 47.9204 72.0835 48.255 71.7652 48.4183C70.946 48.8384 70.1806 49.0789 68.7245 49.3599M70.3751 53.8395C69.9464 52.1447 69.5073 50.8804 68.7245 49.3599M76.7856 54.2259L81.2132 67.5261M81.707 52.4209L86.4382 64.9897",
				stroke: "black",
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2341_110902",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgScopeLight;
